import BaseLayer from 'ol/layer/Base';
import VectorLayer from 'ol/layer/Vector';
import WebGLVector from 'ol/layer/WebGLVector';
import Map from 'ol/Map';

export default class MapLayerUtility {
  static getLayerByProperty(
    fieldViewMap: Map,
    property: 'layerType' | 'name' | 'title',
    propertyValue: string
  ): BaseLayer {
    if (!fieldViewMap) {
      return;
    }

    this.getMapLayersAsArray(fieldViewMap).find(layer => layer.get(property) === propertyValue);
  }

  static removeMapLayersByProperty(
    fieldViewMap: Map,
    property: 'layerType' | 'name' | 'title',
    propertyValue: string | string[]
  ): void {
    if (!fieldViewMap) {
      return;
    }

    const values = Array.isArray(propertyValue) ? propertyValue : [propertyValue];
    const layersToRemove: BaseLayer[] = [];

    this.getMapLayersAsArray(fieldViewMap).forEach(layer => {
      if (values.includes(layer.get(property))) {
        layersToRemove.push(layer);
      }
    });

    layersToRemove.forEach(layer => {
      fieldViewMap.removeLayer(layer);
    });
  }

  static toggleMapLayersVisibilityByProperty(
    fieldViewMap: Map,
    property: 'layerType' | 'name' | 'title',
    propertyValue: string,
    visible: boolean
  ): void {
    if (!fieldViewMap) {
      return;
    }

    this.getMapLayersAsArray(fieldViewMap).forEach(layer => {
      if (layer.get(property) === propertyValue) {
        layer.setVisible(visible);
      }
    });
  }

  static getVectorLayerFromMap(
    fieldViewMap: Map,
    property: 'layerType' | 'name' | 'title',
    propertyValue: string
  ): (VectorLayer | WebGLVector)[] {
    if (!fieldViewMap) {
      return [];
    }

    const layers = this.getMapLayersAsArray(fieldViewMap);
    const matchingLayers = layers.filter(layer => layer.get(property) === propertyValue);

    const vectorLayers = matchingLayers.reduce(
      (acc, layer) => {
        if (layer instanceof VectorLayer || layer instanceof WebGLVector) {
          return acc.concat(layer);
        }
        return acc;
      },
      [] as (VectorLayer | WebGLVector)[]
    );

    return vectorLayers;
  }

  private static getMapLayersAsArray(fieldViewMap: Map): BaseLayer[] {
    if (!fieldViewMap) {
      return [];
    }
    return fieldViewMap.getLayers().getArray();
  }
}
